module.exports = __webpack_public_path__ + "media/images/icons/arrow--left-7daff2cc9e6e63ad263be783533b1c9e.svg";